import React, { useEffect } from 'react';
import { useCart } from './CartContext';
import './CartPanel.css';

function CartPanel({ isOpen, onClose, onCheckout }) {
  const {
    loading,
    getAvailableItems,
    getOffStockItems,
    toggleSelect,
    removeFromCart,
    updateQuantity,
    getSelectedItems,
    getTotalPrice,
    refreshCart
  } = useCart();

  useEffect(() => {
    if (isOpen) {
      refreshCart();
    }
  }, [isOpen, refreshCart]);

  const availableItems = getAvailableItems();
  const offStockItems = getOffStockItems();
  const selectedItems = getSelectedItems();
  const totalPrice = getTotalPrice();

  const handleCheckout = () => {
    if (selectedItems.length > 0) {
      onCheckout(selectedItems);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={onClose} />
      <div className={`cart-panel ${isOpen ? 'open' : ''}`}>
        <div className="cart-header">
          <h3>我的购物车</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="cart-body">
          {loading ? (
            <div className="empty-cart">
              <p>加载中...</p>
            </div>
          ) : availableItems.length === 0 && offStockItems.length === 0 ? (
            <div className="empty-cart">
              <p>🛒 购物车是空的</p>
              <span>快去挑选心仪的商品吧~</span>
            </div>
          ) : (
            <div className="cart-items">
              {availableItems.length > 0 && (
                <>
                  <div className="cart-section-title">
                    <span>可购买商品</span>
                    <span className="section-count">{availableItems.length} 件</span>
                  </div>
                  {availableItems.map(item => (
                    <div key={item.id} className={`cart-item ${item.selected ? 'selected' : ''}`}>
                      <input
                        type="checkbox"
                        checked={item.selected}
                        onChange={() => toggleSelect(item.productId)}
                        className="item-checkbox"
                      />
                      <img
                        src={item.imageUrl || '/placeholder.png'}
                        alt={item.name}
                        className="item-image"
                        onError={(e) => e.target.src = '/placeholder.png'}
                      />
                      <div className="item-info">
                        <h4 className="item-name">{item.name}</h4>
                        <p className="item-desc">
                          {item.description ? item.description.substring(0, 20) + (item.description.length > 20 ? '...' : '') : ''}
                        </p>
                        <div className="item-price">
                          ¥{item.price} × {item.quantity} = <strong>{(item.price * item.quantity).toFixed(2)}</strong>
                        </div>
                      </div>
                      <div className="item-actions">
                        <div className="quantity-control">
                          <button
                            onClick={() => updateQuantity(item.productId, item.quantity - 1)}
                            disabled={item.quantity <= 1}
                            className="qty-btn"
                          >
                            −
                          </button>
                          <span className="qty-value">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                            className="qty-btn"
                          >
                            +
                          </button>
                        </div>
                        <button
                          className="remove-btn"
                          onClick={() => removeFromCart(item.productId)}
                          title="删除商品"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {offStockItems.length > 0 && (
                <>
                  <div className="cart-section-title off-stock-title">
                    <span>已下架商品</span>
                    <span className="section-count">{offStockItems.length} 件</span>
                  </div>
                  {offStockItems.map(item => (
                    <div key={item.id} className="cart-item off-stock-item">
                      <input
                        type="checkbox"
                        checked={false}
                        disabled
                        className="item-checkbox disabled-checkbox"
                      />
                      <div className="off-stock-image-wrapper">
                        <img
                          src={item.imageUrl || '/placeholder.png'}
                          alt={item.name}
                          className="item-image off-stock-image"
                          onError={(e) => e.target.src = '/placeholder.png'}
                        />
                        <span className="off-stock-badge">已下架</span>
                      </div>
                      <div className="item-info off-stock-info">
                        <h4 className="item-name off-stock-name">{item.name}</h4>
                        <p className="item-desc">{item.productStatus === 'deleted' ? '商品已删除' : '该商品已下架'}</p>
                        <div className="item-price off-stock-price">
                          ¥{item.price} × {item.quantity}
                        </div>
                      </div>
                      <div className="item-actions">
                        <button
                          className="remove-btn"
                          onClick={() => removeFromCart(item.productId)}
                          title="删除商品"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>

        {availableItems.length > 0 && (
          <div className="cart-footer">
            <div className="footer-summary">
              <span>已选 <strong>{selectedItems.length}</strong> 件</span>
              <span className="total-price">共需 <strong>{totalPrice.toFixed(2)}</strong> 元宝</span>
            </div>
            <button
              className={`checkout-btn ${selectedItems.length === 0 ? 'disabled' : ''}`}
              onClick={handleCheckout}
              disabled={selectedItems.length === 0}
            >
              立即下单 ({selectedItems.length})
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default CartPanel;
